import React from "react";
import LocationsSelector from "../../../shared/locationsSelector";
import "./header.scss";

import logo from "./../../../assets/images/ikizmet-md.png";
import UserMenu from "../../../shared/userMenuModule/userMenu";
import { useHeaderProps } from "./hooks/useFetchUserProps";

const Header = () => {
  const headerProps = useHeaderProps();
  const { last_data_update_info, lastUpdateClass, currentUser, root_url, showLocationSelector } =
    headerProps || {};

  return (
    <header>
      <div className="navbar-top">
        <div className="navbar-top__logo">
          <a href={root_url}>
            <img src={logo} alt="iKizmet" className="logo ikizmet" />
          </a>
        </div>
        {headerProps && (
          <>
            {showLocationSelector ? (
              <>
                <LocationsSelector {...currentUser} />
                <div className={`last-update-info ${lastUpdateClass}`}>{last_data_update_info}</div>
              </>
            ) : null}

            <UserMenu {...headerProps} />
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
